import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { AuthService } from 'src/app/services/Auth/auth.service';
import { CommonService } from 'src/app/services/Common-function/common.service';
import { BrowserStorageService } from 'src/app/services/browser-storage/browser-storage.service';
import { ShakeAnimationService } from 'src/app/services/shake-animation/shake-animation.service';


@Component({
  selector: 'ipm-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss']
})
export class ChangePasswordComponent implements OnInit, OnChanges {
  @Input() currentUserData: any  = '';
  currentPopType: string = 'change-password'
  constructor(private commonService: CommonService,
    private authService: AuthService,
    public shakeAnimation: ShakeAnimationService,
    private ngxSpinner: NgxSpinnerService,
    private browserService: BrowserStorageService) {
  }

  ngOnInit(): void {
    this.determinePopType();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['currentUserData']) {
      this.determinePopType();
    } 
  }

  private determinePopType(): void {
    if (this.currentUserData) {
      this.currentPopType = 'reset-password';
    } else if (localStorage.getItem('isGuestCheckoutLogin') === 'true') {
      this.currentPopType = 'guest-change-password';
    } else {
      this.currentPopType = 'change-password';
    }
  }

  /**
   * Change password api call
   * @param formData 
   */
  changePasswordApiCall (formData:FormGroup) {
    let className = this.commonService.getClassName('ipm-change-model');
    this.clearError(className);
    let formValue =  formData.value;
    (this.currentPopType === 'change-password' || this.currentPopType === 'guest-change-password') 
      ? this.updatePassword(formValue,className) 
      : this.resetPasswordApiCall(formValue,className);
  }

  /**
   * update password List
   */
  updatePassword(formValue:any, className:any) {
    let  sendData: any = {
      "password":formValue.password
    };
    if (this.currentPopType !== 'guest-change-password') {
      sendData["passwordCurrent"] = formValue.currentPassword;
    }
    
    this.authService.updatePasswordLoginUser(sendData).subscribe( res => {
      this.commonService.showToastSuccess('Your password has been updated.');
      if (this.currentPopType === 'guest-change-password') {
        localStorage.removeItem('isGuestCheckoutLogin');
      }
      this.commonService.closingPopupWithSendData('');
    }, (error) => {
        this.shakeAnimation.addShakeAnimation(className);
        this.shakeAnimation.errorMessage = error.error.message;
    });
  }

  /**
   * reset api call 
   */
  resetPasswordApiCall(formValue:any, className:any) {
    let  sendData = {
      "password":formValue.password
    }
    this.authService.resetPassword(sendData,this.currentUserData.token).subscribe( res => {
      this.commonService.closingPopupWithSendData('notify-popup');
    }, (error) => {
      this.shakeAnimation.addShakeAnimation(className);
      this.shakeAnimation.errorMessage = error.error.message;
    });
  }

  closeByDeviceType() {
    this.commonService.closingPopupWithSendData('');
  }

  /**
  * Clear Error data when change  toggle
  */
  clearError(className:string) {
    this.shakeAnimation.removeClass(className);
  }

}
